import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseInfoRecordController';
export default {
    /**
     * 回收案件
     */
    returnCase: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'returnCase',
        type: requestType.Post,
    },
};
